module.exports = __webpack_public_path__ + "static/img/icon_message.26ff204.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_message.jpg
// module id = 626
// module chunks = 4 7